export default __webpack_public_path__ + "static/0149-78898568222ee6bebb4efd57ac9b0502.png";